export default (theme) => ({
  textField: {
    maxWidth: 250,
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
    },
  },
  divider: {
    margin: '10px 0 5px',
    display: 'block',
    [theme.breakpoints.only('md')]: {
      display: 'none',
    },
  },
  switchesWrapper: {
    padding: '8px 0',
    [theme.breakpoints.only('md')]: {
      padding: '8px 10px',
    },
  },
  marginSmall: {
    marginTop: 16,
    marginBottom: 16,
  },
  paddingBottomRemove: {
    paddingBottom: '0 !important',
  },
  flex: {
    display: 'flex',
    alignItems: 'center',
  },
});
